<template>

    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll">

        <!-- SIDEBAR -->
        <SidebarBody />

        <div class="hp-main-layout">

            <!-- HEADER -->
            <HeaderBody />

            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content">

                <div class="row mb-32 gy-16 dash-top" style="padding-bottom: 500px;">

                    <!-- BANNER -->
                    <div class="col-12 " style="margin-top: -10px;">

                        <div class="hp-bg-black-b py-32 py-sm-64 px-24 px-sm-48 px-md-80 position-relative overflow-hidden hp-page-content"
                            style="border-radius: 20px; background-color: black;">

                            <div class="row ">
                                <div class="col-sm-6 col-12" style="z-index: 50;">
                                    <div class="row">
                                        <div class="col-12">
                                            <h3 class="mb-0 hp-text-color-black-0 dd-none" style="margin-top: 10px;"> Become a creator </h3>
                                            <h1 class="mb-0 hp-text-color-black-0 mm-none"> Become a creator </h1>

                                            <p class=" mb-0 mt-12 hp-text-color-black-60 dd-none"> Ready to turn your passion into profit? Join our community of creators to start building your brand and making money on your terms!  </p>

                                            <p class=" mb-0 mt-12 hp-text-color-black-60 mm-none"> Ready to turn your passion into profit? Join our community of creators and start earning by sharing your unique content.  Become a creator today to start building your brand and making money on your terms!  </p>

                                            <button class="btn btn-primary dd-none" style=" margin-top: 30px; margin-bottom: 10px; padding-top: 15px; padding-bottom: 15px; color: #ffffff;" data-bs-toggle="modal" data-bs-target="#step1" >Create application</button>

                                            <button class="btn btn-primary mm-none" style=" margin-top: 30px;  padding-top: 15px; padding-bottom: 15px; color: #ffffff;" data-bs-toggle="modal" data-bs-target="#step1" >Create application</button>

                                        </div>

                                    </div>
                                </div>

                                <div style="width: 200px; left: 200px; height: 400px; margin-top: -80px; z-index: 48; position: absolute;"
                                    class="vid-shadow mm-none">

                                </div>

                                <div class="col-sm-6 col-12 mm-none" style="z-index: 44;">
                                    <div
                                        style="width: 100%; height: 150px; display: flex; justify-content: center; align-items: center;">

                                        <video style="width: 720px; " autoplay="" muted="" loop>
                                            <source src="@/assets/img/vid3.mp4" type="video/mp4">
                                            Your browser does not support the video tag.
                                        </video>


                                    </div>
                                </div>


                            </div>
                        </div>

                    </div>

                    <!-- POSTS -->
                    <div class="col-12">

                        <div class="row g-32">

                            <div class="col-12 col-xl-12">


                                <!-- TABS -->
                                <ul class="nav nav-tabs mb-12" id="myTab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link active" id="history-tab" data-bs-toggle="tab"
                                            data-bs-target="#history" role="tab" aria-controls="history"
                                            aria-selected="true" style="cursor: pointer;"> History</h6>
                                    </li>
                                </ul>

                                <!-- TAB CONTENT -->
                                <div class="tab-content">

                                    <!-- History -->
                                    <div class="tab-pane fade show active" id="history" role="tabpanel"
                                        aria-labelledby="deposit-tab">

                                        <div class="mt-18 mb-24">

                                            <input type="text" class="form-control" id="exampleInputEmail1"
                                                aria-describedby="emailHelp" style="background-color: transparent;"
                                                placeholder="Search history...">

                                        </div>


                                        <!-- DUPLI -->
                                        <div class="card hp-project-ecommerce-table-card" v-for="hist in historyList" :key="hist.id"
                                            style="margin-bottom: 10px; border-radius: 10px; padding-top: 20px;">
                                            <div class="card-body " >

                                                <div class="row" >

                                                    <div class="col-12">

                                                        <div class="row g-32 ">

                                                            <div class="col-12 col-sm-3 ">

                                                                <div class="row gx-8 gy-16">

                                                                    <div
                                                                        style="display: flex; justify-content: flex-start; align-items: flex-start; cursor: pointer;">

                                                                        <div class="col hp-flex-none w-auto">

                                                                            <img :src="hist.selfieUrl"
                                                                                style="width: 58px; height: 58px; border-radius: 50%;   object-fit: cover; margin-right: 5px; border-color: #000; border-width: 1px; border-style: solid; margin-top: -10px;">

                                                                        </div>


                                                                        <div class="col hp-flex-none w-auto">
                                                                            <!-- <h6 class="mb-4 " style="width: 60%; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ tran.fullname }}</h6> -->
                                                                            <h6 class="mb-4 ">{{ hist.fullLegalName }}</h6>
                                                                            <p
                                                                                class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                                {{ hist.email }}
                                                                            </p>
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <div class="col-6 col-sm-2 ">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong class="mb-4">{{ hist.documentType }}</strong>
                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            Document
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-6 col-sm-2 ">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong class="mb-4">{{ hist.dob }}</strong>
                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            Date of birth
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-6 col-sm-2 ">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong class="mb-4"> ₦ {{ hist.bundle1 }}</strong>
                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            1 month price
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-6 col-sm-2 ">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong class="mb-4"> ₦ {{ hist.bundle2 }}</strong>
                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            3 months price
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-6 col-sm-2 ">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong class="mb-4"> ₦ {{ hist.bundle3 }}</strong>
                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            6 month price
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-6 col-sm-3">
                                                                <div class="row gx-8 gy-16">

                                                                    <div class="col hp-flex-none w-auto">

                                                                        <strong class="mb-4 mm-none">{{ hist.dateFull }}</strong>
                                                                        <strong class="mb-4 dd-none">{{ hist.dateD }}</strong>
                                                                        

                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            Upload date
                                                                        </p>
                                                                    </div>


                                                                </div>
                                                            </div>

                                                            <div class="col-6 col-sm-2">
                                                                <div class="row gx-8 gy-16">

                                                                    <div class="col hp-flex-none w-auto">
                                                                    
                                                                        <strong style="font-size: 14px;" v-if="hist.status == 'pending'"
                                                                            class="badge bg-warning-4 hp-bg-dark-warning text-warning border-none w-auto py-12 px-24 fw-medium ">
                                                                            Pending </strong>

                                                                            <strong style="font-size: 14px;" v-if="hist.status == 'cancelled'"
                                                                            class="badge bg-danger-4 hp-bg-dark-danger text-danger border-none w-auto py-12 px-24 fw-medium ">
                                                                            Declined </strong>

                                                                            <strong style="font-size: 14px;" v-if="hist.status == 'successful'"
                                                                            class="badge bg-success-4 hp-bg-dark-success text-success border-none w-auto py-12 px-24 fw-medium ">
                                                                            Approved</strong>

                                                                    </div>

                                                                </div>
                                                            </div>

                                                            <!-- <div class="col-6 col-sm-2" >
                                                                <div class="row gx-8 gy-16" >
                                                                    
                                                                    <div class="col hp-flex-none w-auto">
                                                                        <button class="btn btn-icon-only rounded-circle btn-primary" data-bs-toggle="modal" data-bs-target="#info" style="cursor: pointer;">
                                                                            <i class="ri-search-line remix-icon"></i>
                                                                        </button>
                                                                        
                                                                    </div>

                                                                </div>
                                                            </div> -->

                                                            <div class="col-12 col-sm-12" >
                                                                <div class="row gx-8 gy-16" >
                                                                    
                                                                    <div class="dd-none">

                                                                        <div class="col hp-flex-none" style="display: flex; justify-content: center; align-items: center; flex-direction: column;">
                                                                        
                                                                            <img :src="hist.frontImageUrl" alt="" style="width: 100%; margin-top: 10px; margin-bottom: 10px; object-fit: cover; height: 400px; border-radius: 10px; ">

                                                                            <img v-if="hist.backImageUrl !=''" :src="hist.backImageUrl" alt="" style="width: 100%; margin-top: 10px; margin-bottom: 10px; object-fit: cover; height: 400px; border-radius: 10px;">
                                                                            
                                                                        </div>

                                                                    </div>

                                                                    <div class="mm-none">

                                                                        <div class="col hp-flex-none" style="display: flex; justify-content: center; align-items: center;">
                                                                        
                                                                            <img :src="hist.frontImageUrl" alt="" style="width: 50%; margin-top: 10px; margin-bottom: 10px; object-fit: cover; height: 400px; border-radius: 10px; margin-right: 10px;">

                                                                            <img v-if="hist.backImageUrl !=''" :src="hist.backImageUrl" alt="" style="width: 50%; margin-top: 10px; margin-bottom: 10px; object-fit: cover; height: 400px; border-radius: 10px;">
                                                                            
                                                                        </div>

                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>



                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; width: 100%; " id="emptyHistory">
                                            <p class="hp-badge-text" style="width: 100%; text-align: center; display: none;">No applications yet...</p>
                                        </div>





                                    </div>


                                </div>

                            </div>


                        </div>

                    </div>

                </div>

                <!-- FOOTER -->
                <FooterBody />

            </div>

        </div>

    </main>
    
    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px"
                width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z">
                    </path>
                </g>
            </svg>
        </button>
    </div>

    <!-- SUCCESS -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="successModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 10px;">

                            <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ successText }}</p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;"
                                @click="closeS">Okay</button>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ERROR -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg "
        ref="errorModal">

        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 30px;">

                            <h5 class="mt-24 mb-16 me-4 text-danger">Error!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ errorText }} </p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;"
                                @click="closeE">Okay</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- LOADING -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="loadingModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">

                        <div class="col-12 text-center">
                            <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;">
                        </div>

                        <div class="col-12 text-center">
                            <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ loadingText }} </p>

                            

                            <div style="position: relative;">

                                <p class="hp-p1-body mb-0" style="margin-top: 10px; position: absolute; bottom: 22px; font-size: 11px; font-weight: 800; width: 100%; text-align: center; color: #9146ff;" id="progressL">  </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- INFO -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="infoModal">

        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-3">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            
                            <i class="hp-text-color-dark-0 ri-2x ri-file-info-line"></i>

                            <h4 class="mt-24 mb-16 me-4">Complete your profile</h4>
                            <p class="hp-p1-body mb-0" style="margin-top: 20px; font-size: 14px; text-align: start;"> Please fill out the following information: </p>

                            <div style="width: 100%; display: flex; justify-content: flex-start; align-items: flex-start; flex-direction: column;">
                                <span style="text-align: start; font-size: 12px; font-weight: 700; margin-top: 20px;" v-if="noProfilePic"> - Profile picture</span>
                                <span style="text-align: start; font-size: 12px; font-weight: 700; margin-top: 10px;" v-if="noProfileBack"> - Profile Background picture</span>
                                <span style="text-align: start; font-size: 12px; font-weight: 700; margin-top: 10px;" v-if="noBio"> - Bio</span>
                            </div>

                            <button class="btn btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 40px; margin-bottom: 10px;"
                                @click="closeI">Okay</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- STEP3 -->
    <div class="modal fade" id="step3" tabindex="-1" aria-labelledby="step3Label" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-sm">
            <div class="modal-content">
                <div class="modal-header">

                    <h4 class="modal-title">Step 3</h4>
                    <button @click="closeStream" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        ></button>
                </div>

                <form @submit.prevent="uploadKyc" class="modal-body" style="margin-top: -40px;">

                    <div style="width: 100%; justify-content: center; align-items: center; display: flex;">
                        <video id="video" width="200" height="200" autoplay style="border-radius: 50%; object-fit: cover; width: 200px; height: 200px;"></video>
                        <canvas id="canvas" width="200" height="200"  style="background-color: #000; width: 200px;   border-radius: 50%;  "></canvas>
                        
                        
                    </div>

                    <div style="width: 100%; justify-content: center; align-items: center; display: flex; margin-top: -20px;">

                        <button type="button"  class="btn btn-icon-only rounded-circle btn-primary" @click="takeSelfie" id="selfieBtn">
                            <i class="hp-text-color-dark-0 iconly-Light-Camera"></i>
                        </button>

                        <button type="button" class="btn btn-icon-only rounded-circle btn-danger" @click="redo" id="redoBtn">
                            <i class="hp-text-color-dark-0 iconly-Light-Delete"></i>
                        </button>
                        
                    </div>

                    <p class=" mb-18 hp-text-color-black-100 " style="font-size: 12px; margin-top: 20px !important;"> Take a selfie holding your ID next to your face. This is to ensure that the ID belongs to you. The photo should be clear and your face must be visible. </p>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-text" data-bs-dismiss="modal" @click="closeStream">Close</button>
                        <button type="submit" class="btn btn-primary">Continue</button>
                    </div>

                </form>


            </div>
        </div>
    </div>

    <!--  PRICES  -->
    <div class="modal fade" id="priceModal" data-bs-backdrop="static" tabindex="-1" aria-labelledby="priceModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">

                    <h4 class="modal-title">Set your prices</h4>
                    <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        ></button> -->
                </div>

                <div class="modal-body" style="margin-top: -40px;">

                    <form @submit.prevent="uploadPrice">

                        <div class="mb-24" style="margin-top: 30px;">

                            <label for="displayName" class="form-label">1 month bundle price</label>
                            <div class="input-group mb-16">
                                <span class="input-group-text" id="basic-addon1">&#8358;</span>
                                <input type="number" class="form-control" placeholder="0.00"
                                    aria-label="Username" aria-describedby="basic-addon1" required v-model="bundle1">
                            </div>

                        </div>

                        <div class="mb-24">

                            <label for="displayName" class="form-label">3 months bundle price</label>
                            <div class="input-group mb-16">
                                <span class="input-group-text" id="basic-addon1">&#8358;</span>
                                <input type="number" class="form-control" placeholder="0.00"
                                    aria-label="Username" aria-describedby="basic-addon1" required v-model="bundle2">
                            </div>

                        </div>

                        <div class="mb-24">

                            <label for="displayName" class="form-label">6 months bundle price</label>
                            <div class="input-group mb-16">
                                <span class="input-group-text" id="basic-addon1">&#8358;</span>
                                <input type="number" class="form-control" placeholder="0.00"
                                    aria-label="Username" aria-describedby="basic-addon1" required v-model="bundle3">
                            </div>

                        </div>

                        <div class="divider mt-18 mb-16"></div>



                        <div class="modal-footer">

                            <!-- <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button> -->
                            <button type="submit" class="btn btn-primary">Continue</button>
                        </div>

                    </form>

                </div>


            </div>
        </div>
    </div>

    <!-- STEP1 -->
    <div class="modal fade" id="step1" tabindex="-1" aria-labelledby="step1Label" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">

                    <h4 class="modal-title">Step 1</h4>
                    
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        ></button>
                </div>

                

                <div class="modal-body" style="margin-top: -40px;">

                    

                    <form @submit.prevent="step1">

                        <div class="mb-24" style="margin-top: 30px;">

                            <label for="displayName" class="form-label">Full legal name </label>
                            <input type="text" class="form-control" placeholder="Legal name" aria-describedby="basic-addon1" required v-model="fullLegalName">

                        </div>

                        <div class="mb-24">

                            <label for="displayName" class="form-label">Date of birth</label>
                            <input type="date" class="form-control" placeholder="dd/mm/yy" aria-describedby="basic-addon1" required v-model="dob">

                        </div>

                        <div class="mb-24">

                            <label for="displayName" class="form-label">Document type</label>
                            <select  v-model="documentType" class="form-select" required>
                                <option value="ninSlip">Nin slip</option>
                                <option value="ninCard">Nin Card</option>
                                <option value="passport">International passport</option>
                                <option value="driver">Driver's license</option>
                            </select>

                        </div>

                        <div class="divider mt-18 mb-16"></div>



                        <div class="modal-footer">

                            <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary">Continue</button>
                        </div>

                    </form>

                </div>


            </div>
        </div>
    </div>

    <!-- STEP2 -->
    <div class="modal fade" id="step2" tabindex="-1" aria-labelledby="step2Label" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">

                    <h4 class="modal-title">Step 2</h4>

                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        ></button>
                </div>

                <div class="modal-body" style="margin-top: -40px;">

                    <p class="hp-p2-body" style="font-size: 12px;">Please be informed that we only need this document to verify your identity. It will be deleted after the verification process is complete. We respect your privacy </p>

                    <form @submit.prevent="step2">

                        <div class="mb-24" style="margin-top: 30px;">

                            <label for="displayName" class="form-label"> Front image of document </label>
                                
                            <input type="file" class="form-control" accept="image/*" id="frontImgSelect"
                                required @change="mediaPreview">
                            <div id="fileSizeText" class="form-text"><span> Image should not be larger than 20(MB)</span></div>

                            <img src="" alt="." id="frontImgPre" class="d-none"
                                style="object-fit: cover; margin-right: 20px; width: 100%; height:  200px; border-radius: 10px;">

                        </div>

                        <div class="mb-24" v-if="documentType == 'ninCard' || documentType == 'driver'">

                            <label for="displayName" class="form-label"> Back image of document</label>
                            <input type="file" class="form-control" accept="image/*" id="backImgSelect" @change="mediaPreview2">
                            <div id="fileSizeText2" class="form-text"><span> Image should not be larger than 20(MB)</span></div>

                            <img src="" alt="." id="backImgPre" class="d-none"
                                style="object-fit: cover; margin-right: 20px; width: 100%; height:  200px; border-radius: 10px;">

                        </div>

                        <div class="divider mt-18 mb-16"></div>


                        <div class="modal-footer">

                            <button type="button" class="btn btn-text" @click="backToStep1">Back</button>
                            <button type="submit" class="btn btn-primary">Continue</button>
                        </div>

                    </form>

                </div>


            </div>
        </div>
    </div>

</template>

<script>

    import SidebarBody from '@/components/SidebarBody.vue';
    import HeaderBody from '@/components/HeaderBody.vue';
    import FooterBody from '@/components/FooterBody.vue';
    import InfiniteLoading from '../../node_modules/v3-infinite-loading/lib/v3-infinite-loading.es';
    import "../../node_modules/v3-infinite-loading/lib/style.css";

    import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, deleteDoc, increment, limit, startAfter, arrayRemove } from "firebase/firestore";
    import { getAuth, onAuthStateChanged, signOut, EmailAuthProvider, reauthenticateWithCredential, } from "firebase/auth";
    import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
    import { db } from '@/firebase';
    import axios from 'axios';
    import Compressor from 'compressorjs';

    

    export default {

        components: {
            SidebarBody,
            HeaderBody,
            FooterBody,
            InfiniteLoading,
        },

        data(){
            return{
                loadingText: "",
                errorText: "",
                successText: "",

                fullName: "",
                email: "",
                userName: "",
                profilePic: "",
                profileBack: "",
                userType: "",
                bio: "",

                profileComplete: true,

                noProfilePic: false,
                noProfileBack: false,
                noBio: false,

                selfieUrl: "",

                fullLegalName: "",
                dob: "",
                dobMonth: "",
                dobDay: "",
                dateSecs: "",
                documentType: "ninSlip",

                stream: null,

                pendingCount: 0,
                successCount: 0,

                historyList: [],
                bundle1: "",
                bundle2: "",
                bundle3: "",

                kycId: "",

                progress: ""

            }
        },

        mounted(){

            document.body.style.overflowY = 'scroll';

            document.getElementById("mobileLogo").style.display = 'none';
            document.getElementById("mobileTitle").textContent = 'Become a creator';

            document.getElementById("moreN").classList.add("active");

            document.getElementById("moreN2").classList.add("active");

            this.getUserInfo();

        },

        methods:{

            closeE() {
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeI() {
                this.$refs.infoModal.classList.remove("bg-active");
                this.$router.push({name: 'profile'});
            },

            round(num, decimals){
                return +(Math.round(num + "e" + decimals) + "e-" + decimals);
            },

            closeS() {
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            async getUserInfo(){

                this.loadingText = "Checking eligibility...";
                this.$refs.loadingModal.classList.add("bg-active");
                
                const auth = getAuth();

                const userRef = doc(db, "Users", auth.currentUser.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {

                    this.userType = userSnap.data().type;
                    this.email = userSnap.data().email;
                    this.profilePic = userSnap.data().profilePic;
                    this.profileBack = userSnap.data().profileBackground;
                    this.fullName = userSnap.data().name;
                    this.userName = userSnap.data().displayId;
                    this.bio = userSnap.data().bio;
                    

                    if(this.profilePic.includes("api.dicebear.com")){
                        this.noProfilePic = true;
                        this.profileComplete = false;
                    }
                    if(this.profileBack.includes("defaultBack2")){
                        this.noProfileBack = true;
                        this.profileComplete = false;
                    }
                    if(this.bio == ""){
                        this.noBio = true;
                        this.profileComplete = false;
                    }


                    // if(!this.profileComplete && sessionStorage.getItem("regType") == "fan"){
                    //     this.$refs.infoModal.classList.add("bg-active");
                    //     this.$refs.loadingModal.classList.remove("bg-active");
                    //     return;
                    // }

                }

                this.getHistory();
                this.$refs.loadingModal.classList.remove("bg-active");
            },

            async getHistory(){

                const auth = getAuth();
                const q = query(collection(db, "UserKyc"), where('userId', '==', auth.currentUser.uid), orderBy("timeStampN"));
                const querySnapshot = await getDocs(q);

                if (querySnapshot.docs.length > 0){

                    document.getElementById("emptyHistory").style.display= "none";

                    querySnapshot.forEach((doc) => {
                    
                        let a1 = Number(doc.data().timeStamp.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().timeStamp.seconds) * 1000));

                        if(doc.data().status == "pending"){
                            this.pendingCount++;
                        }

                        if(doc.data().status == "successful"){
                            this.successCount++;
                        }

                        this.historyList.push({
                            id : doc.id,
                            email: doc.data().email,
                            fullLegalName: doc.data().fullLegalName,
                            selfieUrl: doc.data().selfieUrl,
                            status: doc.data().status,
                            timeStamp: doc.data().timeStamp,
                            dateFull: a2.slice(0, -36),
                            dateD: a2.slice(0, -45),
                            userName: doc.data().username,
                            userId: doc.data().userId,
                            frontImageUrl: doc.data().frontImageUrl,
                            backImageUrl: doc.data().backImageUrl,
                            documentType: doc.data().documentType,
                            dob: doc.data().dob,
                            bundle1: doc.data().bundle1,
                            bundle2: doc.data().bundle2,
                            bundle3: doc.data().bundle3,
                        })

                    });

                    console.log(this.historyList)

                }

                else{
                    document.getElementById("emptyHistory").style.display= "flex";
                }

            },

            backToStep1(){
                $('#step2').modal('hide');
                $('#step1').modal('show');
            },

            mediaPreview() {

                if (document.getElementById("frontImgSelect").files[0] == null) {
                    document.getElementById("frontImgPre").classList.add("d-none");
                    return;
                }

                const fileReader = new FileReader();

                fileReader.readAsDataURL(document.getElementById("frontImgSelect").files[0]);
                fileReader.addEventListener("load", function () {

                    document.getElementById("frontImgPre").classList.add("d-none");
                    document.getElementById("frontImgPre").src = this.result;
                    document.getElementById("frontImgPre").classList.remove("d-none");

                });

            },

            mediaPreview2() {

                if (document.getElementById("backImgSelect").files[0] == null) {
                    document.getElementById("backImgPre").classList.add("d-none");
                    return;
                }

                const fileReader = new FileReader();

                fileReader.readAsDataURL(document.getElementById("backImgSelect").files[0]);
                fileReader.addEventListener("load", function () {

                    document.getElementById("backImgPre").classList.add("d-none");
                    document.getElementById("backImgPre").src = this.result;
                    document.getElementById("backImgPre").classList.remove("d-none");

                });

            },

            step1(){

                console.log(this.pendingCount)

                if(this.pendingCount > 0){
                    this.errorText = "You already have a pending application";
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }

                if(this.successCount > 0){
                    this.errorText = "Your application has already been approved. Sign-in again to update your account status";
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }

                this.dateSecs = new Date(this.dob).getTime() /1000;
                $('#step1').modal('hide');
                $('#step2').modal('show');
            },

            async step2(){

                if(this.documentType == "ninCard" || this.documentType == "driver"){
                    if (document.getElementById("backImgSelect").files[0] == null) {
                        this.errorText = "Please upload the back image of the document to continue";
                        this.$refs.errorModal.classList.add("bg-active");
                        return;
                    }

                    if ( document.getElementById("backImgSelect").files[0] != null && document.getElementById("frontImgSelect").files[0] > 20971520) {
                        this.errorText = "The image is too large. The image should not be larger than is 20MB";
                        this.$refs.loadingModal.classList.remove("bg-active");
                        this.$refs.errorModal.classList.add("bg-active");
                        return;
                    }

                }

                if ( document.getElementById("frontImgSelect").files[0] != null && document.getElementById("frontImgSelect").files[0] > 10971520) {
                    this.errorText = "The image is too large. The image should not be larger than is 10MB";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }

                $('#step2').modal('hide');
                this.uploadKyc();
                // $('#step3').modal('show');

                // document.getElementById("canvas").classList.add("d-none");
                // document.getElementById("redoBtn").classList.add("d-none");

                // this.stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
	            // document.getElementById("video").srcObject = this.stream;

            },

            takeSelfie(){

                let canvas = document.getElementById("canvas");
                canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
   	            this.selfieUrl = canvas.toDataURL('image/jpeg');

                document.getElementById("video").classList.add("d-none");
                document.getElementById("canvas").classList.remove("d-none");

                document.getElementById("selfieBtn").classList.add("d-none");
                document.getElementById("redoBtn").classList.remove("d-none");

            },

            async redo(){
                document.getElementById("selfieBtn").classList.remove("d-none");
                document.getElementById("redoBtn").classList.add("d-none");

                document.getElementById("canvas").classList.add("d-none");
                document.getElementById("video").classList.remove("d-none");
                this.selfieUrl = "";

                this.stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
	            document.getElementById("video").srcObject = this.stream;
                
            },

            closeStream(){
                if(this.stream != null){
                    this.stream.getTracks().forEach(function(track) {
                        track.stop();
                    });
                }
            },

            async uploadKyc(){

                //start loading
                this.loadingText = "Uploading document...";
                this.$refs.loadingModal.classList.add("bg-active");

                // if(this.selfieUrl == ""){
                //     this.errorText = "Please take a selfie with your ID";
                //     this.$refs.loadingModal.classList.remove("bg-active");
                //     this.$refs.errorModal.classList.add("bg-active");
                //     return;
                // }

                // $('#step3').modal('hide');
                // this.closeStream();

                //dob
                let date = new Date(this.dob);
                this.dobMonth = date.getMonth();
                this.dobDay = date.getDay();

                const auth = getAuth();
                const userRef = doc(db, "Users", auth.currentUser.uid);

                await updateDoc(userRef, {
                    dob: this.dob,
                    dobMonth: this.dobMonth,
                    dobDay: this.dobDay
                });

                //upload data
                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs

                let mDocument;
                if(this.documentType == "ninSlip"){
                    mDocument = "NIN Slip";
                }
                else if(this.documentType == "ninCard"){
                    mDocument = "NIN Card";
                }
                else if(this.documentType == "passport"){
                    mDocument = "Int'l Passport";
                }
                else if(this.documentType == "driver"){
                    mDocument = "Driver's License";
                }

                const kycRef = await addDoc(collection(db, "UserKyc"), {

                    userId: auth.currentUser.uid,
                    fullName: this.fullName,
                    username: this.userName,
                    fullLegalName: this.fullLegalName,
                    email: this.email,
                    selfieUrl: sessionStorage.getItem("profilePic"),
                    timeStamp: serverTimestamp(),
                    timeStampN: secs,
                    status: "pending",
                    frontImageUrl: "",
                    backImageUrl: "",
                    documentType: mDocument,
                    dob: this.dob,
                    bundle1: 0,
                    bundle2: 0,
                    bundle3: 0,

                });

                this.kycId = kycRef.id;

                const storage = getStorage();

                let frontImgPre = document.getElementById("frontImgSelect").files[0];
                await this.uploadFrontImg(storage, frontImgPre, kycRef.id, auth.currentUser.uid);

                if(this.documentType == "ninCard" || this.documentType == "driver"){
                    let backImgPre = document.getElementById("backImgSelect").files[0];
                    await this.uploadBackImg(storage, backImgPre, kycRef.id, auth.currentUser.uid);
                }

                //SEND TO ADMIN
                axios.post('https://api.baesnap.com/v1/kyc-mail', {
                    legalName: this.fullLegalName,
                    username: this.userName,
                    uEmail: this.email,
                    
                })
                .then((response) => {
                        
                })
                
                //END
                this.$refs.loadingModal.classList.remove("bg-active");
                $('#priceModal').modal('show');

            },

            uploadFrontImg(storage, imageFile, docId, userId) {

                this.loadingText = "Uploading front image...";
                document.getElementById("progressL").textContent = "";

                return new Promise(function (resolve, reject) {

                    //compress file
                    new Compressor(imageFile, {
                        quality: 0.6,
                        width: 1024,
                        // The compression process is asynchronous,
                        // which means you have to access the `result` in the `success` hook function.
                        success(result) {

                            const storageRef = ref(storage, 'UserKyc/FrontImage/' + userId + '/' + result.name);
                            const uploadTask = uploadBytesResumable(storageRef, result);

                            //Update progress bar
                            uploadTask.on('state_changed',
                                (snapshot) => {
                                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                    
                                    let progressD = progress.toFixed(0);
                                    document.getElementById("progressL").textContent = ""+progressD+"%";
                                    // console.log('Upload is ' + progress + '% done');
                                    switch (snapshot.state) {
                                        case 'paused':
                                            //console.log('Upload is paused');
                                            break;
                                        case 'running':
                                            //console.log('Upload is running');
                                            break;
                                    }
                                },
                                (error) => {
                                    switch (error.code) {
                                        case 'storage/unauthorized':
                                            // User doesn't have permission to access the object
                                            break;
                                        case 'storage/canceled':
                                            // User canceled the upload
                                            break;
                                        case 'storage/unknown':
                                            // Unknown error occurred, inspect error.serverResponse

                                            console.log(error.serverResponse);
                                            return;
                                            break;
                                    }
                                },
                                () => {
                                    // Upload completed successfully, now we can get the download URL
                                    document.getElementById("progressL").textContent = "";
                                    getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {

                                        const kycRef = doc(db, "UserKyc", docId);
                                        await updateDoc(kycRef, {

                                            frontImageUrl: downloadURL,

                                        });

                                        setTimeout(resolve, 1000);

                                    });
                                });

                        },
                        error(err) {
                            console.log(err.message);
                            return;
                        },
                    });

                });

            },

            uploadBackImg(storage, imageFile, docId, userId) {

                this.loadingText = "Uploading back image...";
                document.getElementById("progressL").textContent = "";

                return new Promise(function (resolve, reject) {

                    //compress file
                    new Compressor(imageFile, {
                        quality: 0.6,
                        width: 1024,
                        // The compression process is asynchronous,
                        // which means you have to access the `result` in the `success` hook function.
                        success(result) {

                            const storageRef = ref(storage, 'UserKyc/BackImage/' + userId + '/' + result.name);
                            const uploadTask = uploadBytesResumable(storageRef, result);

                            //Update progress bar
                            uploadTask.on('state_changed',
                                (snapshot) => {
                                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

                                    let progressD = progress.toFixed(0);
                                    document.getElementById("progressL").textContent = ""+progressD+"%";

                                    // console.log('Upload is ' + progress + '% done');
                                    switch (snapshot.state) {
                                        case 'paused':
                                            //console.log('Upload is paused');
                                            break;
                                        case 'running':
                                            //console.log('Upload is running');
                                            break;
                                    }
                                },
                                (error) => {
                                    switch (error.code) {
                                        case 'storage/unauthorized':
                                            // User doesn't have permission to access the object
                                            break;
                                        case 'storage/canceled':
                                            // User canceled the upload
                                            break;
                                        case 'storage/unknown':
                                            // Unknown error occurred, inspect error.serverResponse

                                            console.log(error.serverResponse);
                                            return;
                                            break;
                                    }
                                },
                                () => {
                                    // Upload completed successfully, now we can get the download URL
                                    document.getElementById("progressL").textContent = "";
                                    getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {

                                        const kycRef = doc(db, "UserKyc", docId);
                                        await updateDoc(kycRef, {

                                            backImageUrl: downloadURL,

                                        });

                                        setTimeout(resolve, 1000);

                                    });
                                });

                        },
                        error(err) {
                            console.log(err.message);
                            return;
                        },
                    });

                });

            },

            async uploadPrice(){

                //start loading
                this.loadingText = "Setting prices...";
                this.$refs.loadingModal.classList.add("bg-active");

                if(this.bundle1 < 1000 || this.bundle2 < 1000 || this.bundle3 < 1000){

                    this.errorText= "Price should not be lower than ₦ 1,000";
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;

                }

                const kycRef = doc(db, "UserKyc", this.kycId);
                await updateDoc(kycRef, {
                    bundle1: this.bundle1,
                    bundle2: this.bundle2,
                    bundle3: this.bundle3,
                });

                $('#priceModal').modal('hide');
                this.successText = "Your application was submitted successfully and will be processed in within 72 hours.";
                this.$refs.successModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");

            },

        }
        
        
    }
</script>